import {css} from "@panda/css";

import {BrandHandclapIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {useGetOfferDetailQuery} from "../../../offer/api/get_offer_detail";
import {getCurrency} from "../../../utils/get_currency";

interface IProps {
    isPropertyApplication: boolean;
    offerId?: number;
    price: number | null;
}

export const PreferencesFormWithPriceHeader = ({isPropertyApplication, offerId, price}: IProps) => {
    const {data: offerDetail} = useGetOfferDetailQuery(offerId!, {skip: !offerId});

    const priceText = isPropertyApplication ? "Cena mieszkania:" : "Ceny od:";
    const currency = offerDetail?.currency || Currency.PLN;

    return (
        <div className={containerStyle}>
            <BrandHandclapIcon size="6" wrapperSize="6" wrapperColor="var(--colors-primary)" className={css({mb: 2})} />
            <Text variant="headline_3">Konto założone!</Text>
            <Text variant="body_copy_2" mb={3}>
                Wszystkie ceny na portalu są już dostępne!
            </Text>
            {price && (
                <div className={priceStyle}>
                    <Text variant="headline_6">{priceText}</Text>
                    <Text variant="body_copy_0" strong>
                        <Highlight>{priceFormat(price, {unit: getCurrency({currency})})}</Highlight>
                    </Text>
                </div>
            )}
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid var(--colors-gray-400)",
    alignItems: "center",
    p: 2
});

const priceStyle = css({
    display: "flex",
    flexDirection: "row",
    p: 1,
    backgroundColor: "var(--colors-background-100)",
    borderRadius: 2,
    mb: 1,
    gap: 1
});
import {css} from "@panda/css";

import {BrandHandclapIcon} from "@pg-design/icons-module";
import {Highlight, Text} from "@pg-design/text-module";
import {priceFormat} from "@pg-mono/string-utils";
import {Currency} from "@pg-rp/common-types";

import {useGetOfferDetailQuery} from "../../../offer/api/get_offer_detail";
import {getCurrency} from "../../../utils/get_currency";

interface IProps {
    isPropertyApplication: boolean;
    offerId?: number;
    price: number | null;
}

export const PreferencesFormWithPriceHeader = ({isPropertyApplication, offerId, price}: IProps) => {
    const {data: offerDetail} = useGetOfferDetailQuery(offerId!, {skip: !offerId});

    const priceText = isPropertyApplication ? "Cena mieszkania:" : "Ceny od:";
    const currency = offerDetail?.currency || Currency.PLN;

    return (
        <div className={containerStyle}>
            <BrandHandclapIcon size="6" wrapperSize="6" wrapperColor="var(--colors-primary)" className={css({mb: 2})} />
            <Text variant="headline_3">Konto założone!</Text>
            <Text variant="body_copy_2" mb={3}>
                Wszystkie ceny na portalu są już dostępne!
            </Text>
            {price && (
                <div className={priceStyle}>
                    <Text variant="headline_6">{priceText}</Text>
                    <Text variant="body_copy_0" strong>
                        <Highlight>{priceFormat(price, {unit: getCurrency({currency})})}</Highlight>
                    </Text>
                </div>
            )}
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid var(--colors-gray-400)",
    alignItems: "center",
    p: 2
});

const priceStyle = css({
    display: "flex",
    flexDirection: "row",
    p: 1,
    backgroundColor: "var(--colors-background-100)",
    borderRadius: 2,
    mb: 1,
    gap: 1
});
